module.exports = __webpack_public_path__ + "d95c775f4093c8ec583fe0c5d4adbdec.MP3";